import { render, staticRenderFns } from "./ReqPurchaseByUser.vue?vue&type=template&id=f7e0a5de&scoped=true"
import script from "./ReqPurchaseByUser.vue?vue&type=script&lang=js"
export * from "./ReqPurchaseByUser.vue?vue&type=script&lang=js"
import style0 from "./ReqPurchaseByUser.vue?vue&type=style&index=0&id=f7e0a5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e0a5de",
  null
  
)

export default component.exports